import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  repliedCount: 0,
  notRepliedCount: 0,
  // Conversazioni in cui tocca a noi rispondere (il contatto ha scritto per ultimo).
  awaitingCount: 0,
  // Conteggi lettura globali (server): coerenti su tutte le pagine, non solo su quelle caricate.
  unreadCount: 0,
  readCount: 0,
  // { [pipeline_stage_id]: n. conversazioni collegate a un deal in quella fase }.
  // Alimenta i badge delle tab "filtro per fase" in cima alla lista conversazioni.
  pipelineStageCounts: {},
};

export const getters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 1000, false, 5000);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 7500, false, 20000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  15000,
  false,
  30000
);

const metaDebouncers = {
  default: debouncedFetchMetaData,
  long: longDebouncedFetchMetaData,
  superLong: superLongDebouncedFetchMetaData,
};

// allCount is 0 until a meta request succeeds; under load it stays 0, so treat
// the unknown case as a large account and poll slowest instead of fastest.
export const getMetaDebounceKey = allCount => {
  if (allCount > 2000 || allCount === 0) return 'superLong';
  if (allCount > 100) return 'long';
  return 'default';
};

export const actions = {
  get: ({ commit, state: $state }, params) => {
    metaDebouncers[getMetaDebounceKey($state.allCount)](commit, params);
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      replied_count: repliedCount,
      not_replied_count: notRepliedCount,
      awaiting_count: awaitingCount,
      unread_count: unreadCount,
      read_count: readCount,
      pipeline_stage_counts: pipelineStageCounts,
    } = {}
  ) {
    $state.mineCount = mineCount;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    // I conteggi risposta arrivano solo dagli endpoint lista/meta aggiornati: se assenti
    // (payload piu' vecchio) manteniamo il valore precedente invece di azzerarli.
    if (repliedCount !== undefined) $state.repliedCount = repliedCount;
    if (notRepliedCount !== undefined) $state.notRepliedCount = notRepliedCount;
    if (awaitingCount !== undefined) $state.awaitingCount = awaitingCount;
    if (unreadCount !== undefined) $state.unreadCount = unreadCount;
    if (readCount !== undefined) $state.readCount = readCount;
    // Idem per i conteggi per fase deal: assenti nei payload vecchi -> non azzerare.
    if (pipelineStageCounts !== undefined)
      $state.pipelineStageCounts = pipelineStageCounts;
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
